import type { CatalogMapPoint, CatalogNearMe, RelatedGeoArea } from './catalogsNearMe.types';

/**
 * Redux state slice for Auctions Near Me page
 *
 * Uses catalog-management API to fetch catalogs by geographic bounds.
 * Pagination and filtering are handled server-side.
 */
export type AuctionsNearMeSlice = {
    catalogIds: number[];
    catalogsNearMe: CatalogNearMe[];
    currentPage: number;
    error: string | null;
    loading: boolean;
    mapPoints: CatalogMapPoint[];
    otherPlaces: RelatedGeoArea[];
    totalPages: number;
    totalRecords: number;
    totalUniqueHouses: number;
};

export const defaultAuctionsNearMeSlice: AuctionsNearMeSlice = {
    catalogIds: [],
    catalogsNearMe: [],
    currentPage: 0,
    error: null,
    loading: false,
    mapPoints: [],
    otherPlaces: [],
    totalPages: 0,
    totalRecords: 0,
    totalUniqueHouses: 0,
};
